import * as types from '@/store/mutation-types'

export default {
    namespaced: true,
    state: {
        notifications: []
    },

    actions: {
        getNotification ({ commit }, { centerId, userName, dateTime }) {
            return window.axios.get(`/center/${centerId}/assistant/${userName}/notifications`, { params: { dateTime } }).then((data) => {
                commit(types.STORE_NOTIFICATION, data)
                return data
            })
        }
    },
    mutations: {
        [types.STORE_NOTIFICATION] (state, notifications) {
            state.notifications = notifications
        }
    }
}
